<template>
  <div class="bm-login">
    <!--<h3 class="center">账号登录</h3>-->
    <!--<van-tabs class="tab-box">
      <van-tab title="密码登录">
        <van-cell-group>
          <van-field v-model="userName" label="手机号" placeholder="请输入手机号"/>
          <van-field v-model="password" label="密码" placeholder="请输入密码" />
        </van-cell-group>
        <div class="submit">
          <van-button plain type="primary" size="large" :loading="isLoading" @click="submitHandler"
                      :disabled="isLoading" loading-type="spinner" loading-text="登录中...">登录</van-button>
        </div>
      </van-tab>
      <van-tab title="手机验证">
        <van-cell-group>
          <van-field v-model="userName" label="手机号" placeholder="请输入手机号"/>
          <van-field v-model="smsCode" center label="短信验证码" placeholder="请输入短信验证码">
            <van-button slot="button" size="small" type="primary" @click="sendSmsCode">{{sendCodeLabel}}</van-button>
          </van-field>
        </van-cell-group>
        <div class="submit">
          <van-button plain type="primary" size="large" :loading="isLoading" :disabled="isLoading"
                      @click="submitSmsHandler" loading-type="spinner" loading-text="验证中...">完成</van-button>
        </div>
      </van-tab>
    </van-tabs>
    <div class="action-btn">
      <van-button type="default" size="large" @click="goRegister">快速注册</van-button>
    </div>-->

    <!-- 以上为登录注册老逻辑 -->

    <div class="title" >
      登录&注册
    </div>
    <div class="form" >
      <van-cell-group>
        <van-field
          clearable
          type="number"
          v-model="userName"
          placeholder="请输入手机号码（此号码绑定微信）"
          :error-message="phoneError ? '手机号格式错误' : ''"/>
        <div style="width: 100%; height: 20px" ></div>
        <van-field
          v-model="smsCode"
          center
          clearable
          type="number"
          placeholder="短信验证码"
          :error-message="smsError ? '验证码格式错误' : ''">
          <template slot="button" >
            <div class="get-code" >
              <van-button size="small" type="primary"  @click="sendSmsCode" >{{ sendCodeLabel }}</van-button>
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <div style="width: 100%; height: 50px;" ></div>
      <!--<div class="btn" :class="{active: !phoneError && !smsError}" >登录&注册</div>-->
      <div class="submit">
        <van-button
          plain
          type="primary"
          size="large"
          :loading="isLoading"
          :disabled="!phoneActive || !smsActive"
          @click="submitSmsHandler"
          loading-type="spinner"
          :class="{ active: phoneActive && smsActive }"
          loading-text="验证中...">
          登录&注册</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { sendSmsCode } from '@/api/user'
import { Tab, Tabs, Field, CellGroup, Toast } from 'vant'

Vue.use(Tab).use(Tabs).use(Field).use(CellGroup).use(Toast)

const TIME_COUNT = 60
const beforeSend = '发送验证码'
const afterSend = 's后再次发送'
export default {
  name: 'Login',
  data() {
    return {
      count: TIME_COUNT,
      timer: null,
      show: true,
      isLoading: false,
      userName: '',
      password: '',
      smsCode: '',
      sendCodeLabel: beforeSend,
      phoneError: false,
      smsError: false,
      phoneActive: false,
      smsActive: false
    }
  },
  methods: {
    submitHandler(e) {
      this.isLoading = true
      const params = {
        userName: this.userName,
        password: this.password
      }
      store.dispatch('Login', params).then(() => {
        const query = this.$route.query
        const redirect = decodeURIComponent(query.redirect || '/profile')
        this.$router.push({ path: redirect })
      }).catch(() => {
      }).finally(() => {
        this.isLoading = false
      })
    },
    submitSmsHandler(e) {
      this.isLoading = true
      const params = {
        userName: this.userName,
        smsCode: this.smsCode
      }
      store.dispatch('SmsLogin', params).then(() => {
        const query = this.$route.query
        const redirect = decodeURIComponent(query.redirect || '/profile')
        this.$router.push({ path: redirect })
      }).catch(() => {
      }).finally(() => {
        this.isLoading = false
      })
    },
    sendSmsCode() {
      if (this.timer) return
      if (!this.userName) {
        Toast('请输入正确的手机号')
        return
      }
      this.sendCodeLabel = this.count + afterSend
      sendSmsCode(this.userName).then(
        response => {
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
              this.sendCodeLabel = this.count + afterSend
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
              this.sendCodeLabel = beforeSend
              this.count = TIME_COUNT
            }
          }, 1000)
        }
      )
    },
    goRegister() {
      this.$router.push({name: 'Register', query: this.$route.query})
    }
  },
  watch: {
    userName() {
      let re = /^\d{6,11}$/
      this.phoneActive = this.phoneError = !re.test(this.userName)
      this.phoneActive = !this.phoneError
    },
    smsCode() {
      let re = /^\d{4}$/
      this.smsActive = this.smsError = !re.test(this.smsCode)
      this.smsActive = !this.smsError
    }
  }
}
</script>

<style lang="css">
  .bm-login {

  }
  .bm-login .center {
    text-align: center;
  }
  .bm-login .tab-box {
  }
  .bm-login .submit .van-button--primary {
    height:55px;
    background:rgba(230,230,230,1);
    border-radius:4px;
    font-size:20px;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-align: center;
    line-height: 55px;
    border: none;
  }
  .bm-login .action-btn {
    margin-top: 2px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .title {
    font-size:30px;
    font-weight:400;
    color:rgba(0,0,0,1);
    padding: 20px 15px 5px;
  }

  .form {
    padding: 15px;
  }

  .form ::after {
    border-width: 0;
  }

  .form .van-cell-group .van-cell {
    background-color: #F8F8F8;
  }

  .form .van-cell-group .van-cell:not(:last-child)::after {
    border-bottom: 0
  }

  .form input {
    font-size:16px;
    font-weight:400;
    color:rgba(155,155,155,1);
  }

  .get-code .van-button--primary {
    background-color: #F8F8F8;
    border-color: #F8F8F8;
    font-size:14px;
    font-weight:400;
    color:rgba(50,163,119,1);
    border-left: 2px solid #CFCFCF;
  }

  .btn {
    height:55px;
    background:rgba(230,230,230,1);
    border-radius:4px;
    font-size:20px;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-align: center;
    line-height: 55px;
  }

  .active {
    background-color: #32A377 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue